var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 3.99999C2.3999 3.57565 2.56847 3.16868 2.86853 2.86862C3.16859 2.56856 3.57556 2.39999 3.9999 2.39999H11.9999C12.4242 2.39999 12.8312 2.56856 13.1313 2.86862C13.4313 3.16868 13.5999 3.57565 13.5999 3.99999V10.4C13.5999 10.8243 13.4313 11.2313 13.1313 11.5314C12.8312 11.8314 12.4242 12 11.9999 12H10.2239L10.3223 12.3912L10.9655 13.0344C11.0773 13.1463 11.1535 13.2888 11.1844 13.444C11.2152 13.5991 11.1994 13.76 11.1388 13.9061C11.0783 14.0523 10.9758 14.1772 10.8443 14.2651C10.7127 14.353 10.5581 14.4 10.3999 14.4H5.5999C5.4417 14.4 5.28706 14.353 5.15554 14.2651C5.02401 14.1772 4.9215 14.0523 4.86096 13.9061C4.80042 13.76 4.78458 13.5991 4.81544 13.444C4.84629 13.2888 4.92246 13.1463 5.0343 13.0344L5.6775 12.3912L5.7759 12H3.9999C3.57556 12 3.16859 11.8314 2.86853 11.5314C2.56847 11.2313 2.3999 10.8243 2.3999 10.4V3.99999ZM7.0167 9.59999H3.9999V3.99999H11.9999V9.59999H7.0167Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopComputer);
export default __webpack_public_path__ + "static/media/DesktopComputer.454ba5bf5863936312d067234b10673f.svg";
export { ForwardRef as ReactComponent };